import { TEMOIGNAGES, temoignagesPubliables } from "../content/temoignages";
import type { Temoignage } from "../content/temoignages";

/**
 * Ce qu'en disent ceux qui ont acheté — 02/10/2026. Voir `content/temoignages.ts`.
 *
 * Rien n'est rendu tant qu'aucun témoignage réel et accordé n'existe : une
 * section vide ou meublée d'exemples serait le faux signal que la règle n° 6
 * interdit.
 */
export function Temoignages({ liste = TEMOIGNAGES }: { liste?: ReadonlyArray<Temoignage> }) {
  const publiables = temoignagesPubliables(liste);
  if (publiables.length === 0) return null;
  return (
    <section className="band" id="temoignages">
      <div className="shell narrow">
        <div className="kicker reveal">Ils ont reçu leur rapport</div>
        <h2 className="reveal">Ce qu'en disent ceux qui l'ont acheté</h2>
        {publiables.map((t) => (
          <blockquote className="temoignage reveal" key={`${t.prenom}-${t.metier}-${t.texte.slice(0, 20)}`}>
            <p>« {t.texte} »</p>
            <footer>
              — {t.prenom}, {t.metier}
            </footer>
          </blockquote>
        ))}
      </div>
    </section>
  );
}
